import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HeartPulse, X } from "lucide-react";
import { api } from "../../lib/api";
import { localToday } from "../../lib/wellness";

export const WellnessPrompt = () => {
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();
  const today = localToday();
  const onPage = loc.pathname === "/app/bienestar";
  useEffect(() => {
    if (onPage) return;
    api.get(`/me/wellness/status?local_date=${today}`).then((r) => {
      const p = !r.data.checkin;
      setPending(p);
      if (p && localStorage.getItem("qv_wellness_prompt") !== today) { setModal(true); localStorage.setItem("qv_wellness_prompt", today); }
    }).catch(() => {});
  }, [today, onPage]);
  if (onPage || !pending) return null;
  const go = () => { setModal(false); nav("/app/bienestar"); };
  return (
    <>
      <button onClick={go} data-testid="wellness-banner" style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left", cursor: "pointer", background: "rgba(225,29,46,0.1)", border: "1px solid rgba(225,29,46,0.45)", color: "#fff", padding: "12px 14px", fontSize: 14, marginBottom: 16 }}>
        <HeartPulse size={18} color="#E11D2E" /><span style={{ flex: 1 }}><b>Cuestionario de hoy pendiente.</b> 1 minuto para ajustar tu sesión.</span><span style={{ color: "#E11D2E", fontWeight: 700 }}>Rellenar</span>
      </button>
      {modal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", backdropFilter: "blur(14px)", zIndex: 200, display: "flex", alignItems: "flex-end", justifyContent: "center" }} data-testid="wellness-modal">
          <div className="qv-card-app" style={{ width: "100%", maxWidth: 480, padding: 24, position: "relative", animation: "fadeIn .3s ease" }}>
            <button onClick={() => setModal(false)} style={{ position: "absolute", top: 12, right: 12, background: "none", border: "none", color: "#a3a3a3", cursor: "pointer" }} data-testid="wellness-modal-close"><X size={18} /></button>
            <HeartPulse size={28} color="#E11D2E" />
            <div style={{ fontFamily: "Bebas Neue", fontSize: 30, marginTop: 8 }}>¿Cómo llegas hoy?</div>
            <div style={{ fontSize: 14, color: "#a3a3a3", margin: "6px 0 18px" }}>Responde tu cuestionario diario (menos de un minuto) y te diremos cómo enfocar la sesión de hoy.</div>
            <button className="qv-btn-primary" style={{ width: "100%", padding: 14 }} onClick={go} data-testid="wellness-modal-go">Rellenar ahora</button>
            <button className="qv-btn-ghost" style={{ width: "100%", padding: 12, marginTop: 8 }} onClick={() => setModal(false)} data-testid="wellness-modal-later">Más tarde</button>
          </div>
        </div>
      )}
    </>
  );
};
